import { render } from "./SidebarLogo.vue?vue&type=template&id=4cc050b2&scoped=true"
import script from "./SidebarLogo.vue?vue&type=script&lang=ts"
export * from "./SidebarLogo.vue?vue&type=script&lang=ts"

import "./SidebarLogo.vue?vue&type=style&index=0&id=4cc050b2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4cc050b2"

export default script